import React from 'react'
import ReactDOM, {findDOMNode} from 'react-dom'
import styles from './HoverCard.scss'
import base from 'lib/styleguide/base.scss'
import tippy from 'tippy.js'
import cx from 'classnames'
import _ from 'lodash'
import PropTypes from 'prop-types'

export class HoverCard extends React.PureComponent {
  static propTypes = {
    theme: PropTypes.string,
    onHidden: PropTypes.func, // tippy.js lifecycle method
    showOnMount: PropTypes.bool, // call tippy.show() during componentDidMount()
    arrow: PropTypes.bool, // whether or not to show an arrow pointing at the target
    tippyOptions: PropTypes.object // A plain object that gets mixed in with default tippy.js options
  }

  constructor (props) {
    super(props)
    this.container = document.createElement('div')
  }

  onHidden = () => {
    const {onHidden} = this.props
    onHidden && onHidden()
  }

  onShow = () => {
    // onShow() gets called as this hovercard starts to get transitioned in
    // calling .hideAllPopovers() is pretty indiscriminate
    // if we need more precision, maybe just hide all tippys on scroll?
    // https://atomiks.github.io/tippyjs/misc/#hide-tooltips-on-scroll
    // Or we could inspect a tippy and determine whether it was created
    // via a <Hovercard /> and only destroy those.  For now, this is good
    // since it ensures no overlapping tippys

    const poppers = Array.from(document.querySelectorAll('.tippy-popper'))
    poppers.forEach(popper => {
      // If you pass 0 as the duration, you can make all of them hide instantly
      popper._tippy.hide(0)
    })
  }

  componentDidMount () {
    const {target, showOnMount, tippyOptions, arrow, theme} = this.props
    const tippyOpts = Object.assign({
      interactive: true,
      html: this.container,
      animateFill: false,
      placement: 'top',
      duration: [200, 200],
      delay: [500, 0],
      theme: 'light',
      onHidden: this.onHidden,
      onShow: this.onShow
    },
    tippyOptions,
    arrow && {arrow: true, arrowTransform: 'scale(2)'},
    theme && {theme}
    )

    this._node = _.isElement(target) ? target : findDOMNode(target)

    this._tippy = tippy(this._node, tippyOpts)

    if (showOnMount) {
      this._node._tippy.show()
    }
  }

  componentWillUnmount () {
    // Destroy the tippy.js instance
    this._node && this._node._tippy && !this._node._tippy.state.destroyed && this._node._tippy.destroy()
  }

  render () {
    const {className, children} = this.props

    const previewContent = (
      <div className={cx(styles.HoverCard, className, base.base)}>
        {children}
      </div>
    )

    return ReactDOM.createPortal(
      previewContent,
      this.container
    )
  }
}
